import { AmusmentLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Forms = [
  {
    fileStoreId: "18015926-2a59-4f3c-8a94-891f18042026",
    label: "Form for Permission under Section 422 of the C.M.C. Act,1980s",
  },
];

const Amusement_download_forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"Forms List"}
    list={Forms}
    leftMenuList={AmusmentLeftMenuList}
    longMenuList={true}
  />
);

export default Amusement_download_forms;
